<template>
    <div>
        <h4>Create by defining a range of serial numbers</h4>

        <div class="item-attribute">
            <label class="item-attribute-title">Initial serial number</label>
            <b-form-input :state="state_input_serial_number" class="bolded item-attribute-value" v-model="initial_serial_number">{{initial_serial_number}}</b-form-input>
        </div>

        <div class="item-attribute">
            <label class="item-attribute-title">Range</label>
            <b-form-input :state="state_input_range_number" type="number" class="bolded item-attribute-value" v-model="range">{{range}}</b-form-input>
        </div>

        <div v-if="serial_number_list.length > 0" class="form-group  text-left" style="margin-top: 2rem;">
            <label>Serials</label>
            <div style="margin-top: 0.5rem; margin-bottom: 1rem;">
                <b-table id="items-table" outlined bordered
                    :items="serial_number_list"
                    style="width: 50%; text-align: left;">
                </b-table>
            </div>
        </div>
        <b-btn style="margin-top: 1rem;" class="btn btn-md btn-success" variant="success" :disabled="is_creating || !state_input_serial_number || !state_input_range_number" v-on:click="clickedCreate">
            <i v-show="is_creating" class="fa fa-spinner fa-spin"></i> Create
        </b-btn>
        <!--
        <b-btn v-show="serial_number_list.length > 0" style="margin-top: 1rem;" class="btn btn-md btn-success" variant="success" :disabled="is_creating" v-on:click="clickedCreate">
            <i v-show="is_creating" class="fa fa-spinner fa-spin"></i> Create
        </b-btn>
        -->
    </div>
</template>

<script>

import utils from "../../utils.js"

import DEVICE_API from '../../api/device'
import DEVICE_GROUP_API from '../../api/device_group'

import bTable from 'bootstrap-vue/es/components/table/table'

const SERIAL_NAME_COLUMN = "Serial";

import { RANGE_MAX } from "../../constants.js"

import moment from 'moment'

export default {
    data () {
        return {
            initial_serial_number: "",

            state_input_serial_number: false,
            state_input_range_number: false,

            range: 0,

            disable_all: false,
            selected_product: "IP051",

            loading_file: false,

            is_creating: false,

            serial_number_list: []
        }
    },

    components: {
        bTable
    },

	mounted () {
		console.log('RangeUploadComponent mounted')
	},

    watch: {
        range: function(val, oldVal) {
            if (val <= 0 || val > RANGE_MAX) {
                this.state_input_range_number = false
            } else {
                this.state_input_range_number = true
            }
        },

        initial_serial_number: function(val, oldVal) {
            if (utils.validateSerialNumber(val)) {
                this.state_input_serial_number = true
            } else {
                this.state_input_serial_number = false
            }
        },
    },

    methods: {
        clickedCreate: function() {
            this.disable_all = true
            this.is_creating = true

            this.createGroup()
        },

        createGroup: function() {
            console.debug("createGroup")

            const device_group_name = "GROUP-BULK-" + this.selected_product + "-" + moment().format('MMMM Do YYYY, hh:mm:ss')

            const postParamsAddNewGroup = {
                product_name: this.selected_product,
                device_group_name: device_group_name,
                branch: "undefined",
                sw_version: "undefined",
                variant: "undefined",
                signing_version: "undefined"
            };

            const reference = this

            DEVICE_GROUP_API.addGroup(
                postParamsAddNewGroup,
                () => {
                    console.debug("Added Group");

                    reference.createDevices(device_group_name)
                },
                e => {
                    console.debug(e)

                    reference.disable_all = false
                    reference.is_creating = false

                    utils.makeToast(reference.$bvToast, "Error", "danger", 'There was a problem creating one of more device')
                }
            );
        },

        createDevices: function(device_group_name) {
            console.debug("createDevices")

            const params = {
                serial_number : this.initial_serial_number,
                range: this.range,
                product_name: this.selected_product,
                device_group_name: device_group_name
            }

            const reference = this;

            DEVICE_API.addMultipleViaRange(params,
                () => {
                    reference.disable_all = false
                    reference.is_creating = false

                    reference.serial_number_list = []

                    reference.initial_serial_number = ''
                    reference.range = 0

                    utils.makeToast(reference.$bvToast, "Success", "success", 'Your new devices are ready to use!')
                },
                e => {
                    console.debug(e)

                    reference.disable_all = false
                    reference.is_creating = false

                    utils.makeToast(reference.$bvToast, "Error", "danger", 'There was a problem creating one of more device')
                }
            );
        }            
    },
}
</script>

<style lang="stylus" scoped>
.container-color
    display: flex; 
    flex-direction: row; 
    align-items: center; 

</style>